import { useCallback, useEffect, useMemo, useState } from "react";
import { useGetModels } from "../useGetModels";
import { groupModelsByProvider } from "../../utils";

export const useLLMModel = () => {
  const { fetch: getModels, data: modelsList, loading: loadingProviders } = useGetModels();
  const [selectedModelId, setSelectedModelId] = useState<string | undefined>();

  const providers = useMemo(() => groupModelsByProvider(modelsList), [modelsList]);

  const modelInfo = useMemo(() => {
    return modelsList?.models.find((model) => model.modelId === selectedModelId);
  }, [selectedModelId, modelsList]);

  const resetModel = useCallback(() => {
    setSelectedModelId(modelsList?.defaultModelId);
  }, [setSelectedModelId, modelsList]);

  useEffect(() => {
    getModels().then((result) => {
      if (result) {
        setSelectedModelId(result.data?.defaultModelId);
      }
    });
  }, [getModels, providers?.defaultModelId]);

  return {
    providers,
    selectedModelId,
    setSelectedModelId,
    resetModel,
    modelInfo,
    loadingProviders,
  };
};
